import {NetworkStatus} from '@/constants';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface NetworkState {
  status: NetworkStatus;
}

const initialState: NetworkState = {
  status: NetworkStatus.ACTIVE
};

const networkSlice = createSlice({
  name: 'network',
  initialState,
  reducers: {
    setNetworkStatus(state, action: PayloadAction<NetworkStatus>) {
      state.status = action.payload;
    }
  }
});

export const {setNetworkStatus} = networkSlice.actions;

export default networkSlice.reducer;
